import some from 'lodash/some';

import { DEFAULT_POSITION, NodeSize } from 'src/presentation/components/pages/ivr/constants/ivrTreeConstants';
import { IvrNodePosition, IvrNodeCoordinates } from 'src/models/Ivrs/IvrTreeData';

const MAX_NODE_SHIFT = 20;

export const calculateNodePosition = ({
  height = NodeSize.Default.height,
  locationState,
  parentId,
  width = NodeSize.Default.width,
  stepX = NodeSize.Default.width,
}: {
  height?: number;
  parentId?: string;
  width?: number;
  stepX?: number;
  locationState: IvrNodePosition;
}): IvrNodeCoordinates => {
  if (!parentId) {
    return DEFAULT_POSITION;
  }
  const parentPosition = locationState[parentId];
  const position = locationState[parentId] ? { x: parentPosition.x, y: parentPosition.y + 120 } : DEFAULT_POSITION;

  for (let i = 0; i < MAX_NODE_SHIFT; i++) {
    if (!isOverlapping({ locationState, coords: position, width, height })) {
      break;
    }
    position.x += stepX;
  }
  return position;
};

const isOverlapping = ({
  coords: nodeCoordinates,
  height = NodeSize.Default.height,
  locationState,
  width = NodeSize.Default.width,
}) =>
  some(Object.keys(locationState), nodeId => {
    const position = locationState[nodeId];
    const delta = 10;
    const l1 = [position.x - delta, position.y + NodeSize.Default.height + delta];
    const r1 = [position.x + NodeSize.Default.width + delta, position.y - delta];

    const l2 = [nodeCoordinates.x, nodeCoordinates.y + height];
    const r2 = [nodeCoordinates.x + width, nodeCoordinates.y];

    if (l1[0] >= r2[0] || l2[0] >= r1[0]) {
      return false;
    }

    if (l1[1] <= r2[1] || l2[1] <= r1[1]) {
      return false;
    }
    return true;
  });
